export const Sexe = {
    MALE: 'MALE',
    FEMALE: 'FEMALE',
    VALUES: ['MALE', 'FEMALE']
};

export class User{
    constructor(obj){
        if(!obj) {
            return;
        }
        this.id = obj.id;
        this.email = obj.email;
        this.lastName = obj.lastName;
        this.firstName = obj.firstName;
        if(obj.birthDate) {
            this.birthDate = new Date(obj.birthDate);
        }
        this.permissions = obj.permissions;
        this.sexe = obj.sexe;
        this.cardExpiration = obj.cardExpiration;
        this.cardNom = obj.cardNom;
        this.phoneNumber = obj.phoneNumber;
        this.phoneNumber2 = obj.phoneNumber2;
        this.address = obj.address;
        this.localisation = obj.localisation;
        this.color = obj.color;
        this.hidden = !!obj.hidden;
        this.driverInformation = obj.driverInformation;
        this.cra = obj.cra;
        this.actif = !!obj.actif;
        this.files = obj.files;
        this.role = obj.role;
    }

    get isSuperAdmin() { return this.role && this.role.designation === 'SADMIN'; }
    get isAdmin(){ return this.isSuperAdmin || this.role &&  this.role.designation === 'ADMIN'; }
    get isManager(){ return this.isAdmin || this.role && this.role.designation === 'MANAGER'; }
    get isClient(){ return this.role && this.role.designation === 'CLIENT'; }
}

